// import action from '../helpers/rest-client'
import {
  MediaActions, MediaEntities
} from '../types/miscelaneos/media.dto';
import services from '.';
import actions from '../helpers/rest-client';

// xhrInstances is an array with XMLHttpRequest instances for tracking ongoing requests
let xhrInstances: XMLHttpRequest[] = [];

/**
 * Function to get a signed URL for file upload or download.
 * @param {Object} params - The parameters for getting the signed URL.
 * @param {string} params.fileName - The name of the file.
 * @param {string} [params.fileType] - The type of the file (optional).
 * @param {MediaActions} params.action - The action to be performed (e.g., WRITE or READ).
 * @returns {Promise<Object>} - The response or error from the request.
 */
const getSignedUrl = async ({ fileType, fileName, filePath, action }: { fileType?: string, fileName: string, filePath: string, action: MediaActions }) => {
  const token = services.auth.getToken();
  const url = `${process.env.REACT_APP_API_URL}/media/get-signed-url?filePath=${filePath}&fileName=${fileName}&fileType=${fileType}&action=${action}&expiration=1800`;

  try {
    const fetchResponse = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
    });

    // Verificar si la respuesta es exitosa (status code 2xx)
    if (fetchResponse.ok) {
      // Si la respuesta es exitosa, analizar el cuerpo de la respuesta como JSON
      const response = await fetchResponse.json();
      return { response, error: null };
    } else {
      // Si la respuesta no es exitosa, lanzar un error con el mensaje de estado
      const error = await fetchResponse.text();
      return { error: `Fetch error: ${fetchResponse.status} - ${error}` };
    }
  } catch (error) {
    // Capturar errores de análisis JSON o errores de red
    console.error("Error fetching data:", error);
    return { response: null, error };
  }
};

/**
 * Function to upload a file with progress tracking.
 * @param {Object} params - The parameters for uploading the file.
 * @param {string} params.url - The URL to upload the file to.
 * @param {File} params.file - The file to be uploaded.
 * @param {Function} params.onUploadProgress - Callback function to handle upload progress.
 * @param {Function} params.onAbort - Callback function to handle upload abort.
 * @returns {Promise<Object>} - The response or error from the upload.
 */
const storePut = async ({ url, file, onUploadProgress, onAbort }) => {
  const uploadFileWithProgress = async ({ url, file, onUploadProgress, onAbort }: { url: string, file: File, onUploadProgress: (progress) => void, onAbort: () => void }) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100;
          onUploadProgress(progress);
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Successful upload
          resolve(xhr.response);
        } else {
          // Upload error
          reject(new Error(`Failed to upload file. Status: ${xhr.status}`));
        }
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Network error during file upload.'));
      });

      xhr.addEventListener('abort', () => {
        reject(onAbort());
      });

      console.log(file.type)

      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);

      try {
        xhrInstances.push(xhr);

      } catch (error) {
        console.log('HERE IS THE ERROR', error)
      }
    });
  };

  return uploadFileWithProgress({ url, file, onUploadProgress, onAbort })
    .then((response) => {
      return { response };
    })
    .catch((error) => {
      return { error };
    });
};

/**
 * Function to abort all ongoing file uploads.
 */
export const abortUpload = () => {
  if (xhrInstances.length > 0) {
    for (let index = 0; index < xhrInstances.length; index++) {
      const xhrInstance = xhrInstances[index];
      xhrInstance.abort();
      console.log('XHR request aborted.');
    }
  } else {
    console.warn('No active XHR request to abort.');
  }
};

/**
 * Function to generate the path for files based on the entity type.
 * @param {Object} params - The parameters for generating the path.
 * @param {string} params.entity - Enum between doctor | patient | company.
 * @param {string} params.idCompany - The company id.
 * @param {string} [params.idDoctor] - The doctor id (required if entity is doctor).
 * @param {string} [params.idPatient] - The patient id (required if entity is patient).
 * @param {string} params.fileName - The file name.
 * @param {string} params.fileExt - The file extension.
 * @returns {string} - The path for the selected entity.
 */



export const getFilePath = ({
  entity,
  fieldName,
  idCompany,
  idUser,
  idResponsible,
  idCustomer,
  year,
  month,
  type,
  statement
}: {
  entity: MediaEntities,
  fieldName: string,
  idCompany: string,
  idUser?: string,
  idResponsible?: string,
  idCustomer?: string,
  year?: string | number
  month?: string | number
  type?: string
  statement?: string
}) => {
  if (!idCompany) {
    console.error("idCompany is required");
    return;
  }

  if (!entity) {
    console.error("entity is required");
    return;
  }

  if (!fieldName) {
    console.error("fieldName is required");
    return;
  }


  switch (entity) {
    case MediaEntities?.COMPANY:
      return `company/${idCompany}/${fieldName}/`;

    case MediaEntities?.CUSTOMER:
      if (!idCustomer) {
        console.error("idCustomer is required");
        return;
      }
      return `company/${idCompany}/${entity}/${idCustomer}/${fieldName}/`;

    case MediaEntities?.USER:
      if (!idUser) {
        console.error("idUser is required");
        return;
      }
      return `company/${idCompany}/${entity}/${idUser}/${fieldName}/`;

    case MediaEntities?.RESPONSIBLE:
      if (!idResponsible) {
        console.error("idResponsible is required");
        return;
      }
      return `company/${idCompany}/${entity}/${idResponsible}/${fieldName}/`;

    case MediaEntities?.INSPECTION:
      if (!idCustomer) {
        console.error("idCustomer is required");
        return;
      }
      if (!statement) {
        console.error("statement is required");
        return;
      }
      return `company/${idCompany}/customer/${idCustomer}/${entity}/${statement}/${fieldName}/`;

    case MediaEntities?.PERIODIC_CHECK:
      if (!idCustomer) {
        console.error("idCustomer is required");
        return;
      }

      if (!year) {
        console.error("year is required");
        return;
      }

      if (!month) {
        console.error("month is required");
        return;
      }

      if (!type) {
        console.error("type is required");
        return;
      }

      return `company/${idCompany}/customer/${idCustomer}/${entity}/${year}/${month}/${type}/${fieldName}/`;

    default:
      console.error("Invalid entity type - ABORT FILE UPLOAD");
      return
  }
};


class Storage {
  /**
   * Function to save a file with progress tracking.
   * @param {Object} params - The parameters for saving the file.
   * @param {File} params.file - The file to be saved.
   * @param {string} params.fileName - The name to save the file as.
   * @param {Function} params.onUploadProgress - Callback function for upload progress.
   * @param {Function} [params.onAbort] - Callback function for upload abort (optional).
   * @returns {Promise<Object>} - The response or error from saving the file.
   */
  async saveFile({ file, filePath, fileName, fileType, onUploadProgress, onAbort }): Promise<{ response?: any; error?: any }> {
    if (!file || !filePath || !fileName || !fileType) {
      console.error("One or more properties to save the file are empty", { file, filePath, fileName, fileType })
      return { response: null, error: "One or more properties to save the file are empty" }
    }

    const { response, error } = await getSignedUrl({
      filePath,
      fileName,
      fileType,
      action: MediaActions.WRITE,
    });

    if (!!response) {
      const { url } = response;
      console.log("response", url)
      return storePut({ url, file, onUploadProgress, onAbort });
    } else {
      return { error };
    }
  }

  /**
   * Function to get a file URL for download.
   * @param {Object} params - The parameters for getting the file URL.
   * @param {string} params.fileName - The name of the file to be retrieved.
   * @returns {Promise<Object>} - The URL to the file or an error.
   */
  async getFile({ filePath, fileName }) {
    const { response, error } = await getSignedUrl({
      filePath,
      fileName,
      action: MediaActions.READ,
    });

    if (!!response) {
      const { url } = response;
      return url;
    } else {
      return { error };
    }
  }

  /**
   * Function to get a file URL for download.
   * @param {Object} params - The parameters for getting the file URL.
   * @param {string} params.fileName - The name of the file to be retrieved.
   * @returns {Promise<Object>} - The URL to the file or an error.
   */
  async getMediaUrl({ idMedia }): Promise<{ url: string }> {
    return actions
      .Get({
        url: `/media/get-media-url/${idMedia}`,
      })
      .then(response => {
        return response
      })
      .catch(error => {
        console.error(error)
        return ''
      })
  }

  /**
   * Function to get a file URL for download.
   * @param {Object} params - The parameters for getting the file URL.
   * @param {string} params.fileName - The name of the file to be retrieved.
   * @returns {Promise<Object>} - The URL to the file or an error.
   */
  async deleteMedia({ idMedia }): Promise<{ url: string }> {
    return actions
      .Del({
        url: `/media/${idMedia}`,
      })
      .then(response => {
        return response
      })
      .catch(error => {
        console.error(error)
        return ''
      })
  }
}

const storage = new Storage();
export default storage;
